import {
  Create,
  SimpleForm,
  ReferenceInput,
  DateTimeInput,
  SelectInput,
  AutocompleteInput,
  useRedirect,
  Toolbar,
  SaveButton,
  Button,
  required,
  NumberInput,
  BooleanInput,
} from "react-admin";
import { useLocation } from "react-router-dom";
import { integerOnly } from "../validators";
import { format } from "date-fns";

const statusChoises = [
  { id: "PENDING", name: "En attente" },
  { id: "CONFIRMED", name: "Confirmé" },
  { id: "CANCELLED", name: "Annulé" },
];

const AppointmentCreateToolbar: React.FC = (props) => {
  const redirect = useRedirect();
  return (
    <Toolbar {...props}>
      <SaveButton />
      <Button
        variant="outlined"
        color="secondary"
        size="large"
        onClick={() => redirect("list", "appointments")}
        sx={{ ml: 2, pl: 4 }}
      >
        Annuler
      </Button>
    </Toolbar>
  );
};

export const AppointmentCreate: React.FC = (props) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const scheduledAtRem = params.get("scheduledAt") || new Date();
  let scheduledAt: Date | string = new Date(scheduledAtRem);
  scheduledAt.setHours(8);
  scheduledAt.setMinutes(0);
  scheduledAt = format(scheduledAt, "yyyy-MM-dd'T'HH:mm");
  return (
    <Create {...props} title="Prendre un rendez-vous" redirect="list">
      <SimpleForm toolbar={<AppointmentCreateToolbar />}>
        <ReferenceInput
          source="provider"
          reference="providers"
          label="Prestataire"
          perPage={50}
        >
          <AutocompleteInput
            optionText="name"
            fullWidth
            label="Prestataire"
            validate={[required("Le prestataire est requis")]}
            filterToQuery={(searchText: any) => ({
              filterTree: {
                operator: "and",
                operands: [
                  {
                    term: {
                      name: "name",
                      filterType: "like",
                      value: searchText,
                    },
                  },
                ],
              },
            })}
          />
        </ReferenceInput>
        <ReferenceInput
          source="outlet"
          reference="outlets"
          label="Exutoire"
          perPage={50}
        >
          <AutocompleteInput
            optionText="name"
            fullWidth
            label="Exutoire"
            validate={[required("L'exutoire est requis")]}
            filterToQuery={(searchText: any) => ({
              filterTree: {
                operator: "and",
                operands: [
                  {
                    term: {
                      name: "name",
                      filterType: "like",
                      value: searchText,
                    },
                  },
                ],
              },
            })}
          />
        </ReferenceInput>
        <DateTimeInput
          source="scheduledAt"
          label="Date & heure"
          validate={[required("La date du RDV est requise")]}
          defaultValue={scheduledAt}
        />
        <NumberInput
          source="quantityBin"
          label="Quantité de caisse pleines à récuperer par l'exutoire"
          validate={[
            required("La quantité de caisse est requise"),
            integerOnly("Doit être un nombre décimal"),
          ]}
        />
        <NumberInput
          source="quantityBinToBeCollected"
          label="Quantité de caisse vide à récuperer"
          defaultValue={208}
          validate={[
            required("La quantité de caisse est requise"),
            integerOnly("Doit être un nombre décimal"),
          ]}
        />
        <SelectInput
          source="status"
          label="Statut"
          defaultValue={statusChoises[0].id}
          choices={statusChoises}
          validate={[required("Le status est requis")]}
        />
        <BooleanInput
          label="Envoyer le mail au prestataire avec le QR code?"
          source="sendEmailToProvider"
          defaultValue={true}
          defaultChecked={true}
        />
      </SimpleForm>
    </Create>
  );
};
